import { StoresList } from '@/models/enums/app/StoresList'
import { defineStore } from 'pinia'
import { ref, type Ref } from 'vue'
import type { Domaine } from '@/models/interfaces/Domaine'
import { DomaineService } from '@/services/domaine/DomaineService'

export const useDomaineStore = defineStore(StoresList.DOMAINE, () => {
  const domaineList: Ref<Domaine[]> = ref([])

  async function getAll(): Promise<void> {
    if (domaineList.value.length === 0) {
      domaineList.value = await DomaineService.getAll()
    }
  }

  return {
    domaineList,
    getAll,
  }
})
